import * as React from "react";
import * as ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import * as i18n from "i18n";

import BusyOverlay from "components/busyOverlay";
import App from "./app";
import Shell from "core/infrastructure/shell";
import { config } from "@fortawesome/fontawesome-svg-core";

interface Configuration {
    applicationRoot: string;
    scriptsRoot: string;
    apiService: string;
    requestVerificationToken: string;
    bearerToken: string;
    username: string;
    role: string;
    environment: string;
}

export default (el: Element, configuration: Configuration) => {
    __webpack_public_path__ = configuration.scriptsRoot; // needed for chunk loading

    axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
    axios.defaults.headers.common["RequestVerificationToken"] = configuration.requestVerificationToken;
    //TODO axios.defaults.headers.common["Authorization"] = "Bearer ...";

    axios.interceptors.response.use(
        response => response,
        error => Promise.reject(error)
    );

    i18n.init(configuration.scriptsRoot, ["common"]);

    const container =
        <React.Suspense fallback={<BusyOverlay />}>
            <Shell>
                <BrowserRouter basename={configuration.applicationRoot}>
                    <App applicationRoot={configuration.applicationRoot}
                        apiService={configuration.apiService}
                        bearerToken={configuration.bearerToken}
                        username={configuration.username}
                        role={configuration.role}
                        environment={configuration.environment} />
                </BrowserRouter>
            </Shell>
        </React.Suspense>;

    ReactDOM.render(container, el);
};